<script setup lang="ts">
import type { SerializedEditorState } from "lexical";

import { ColorHex } from "~/shared/enums";
import { BACKGROUND_ALPHA } from "~/utils/color";

import CodeHighlightPlugin from "./plugins/CodeHighlightPlugin.vue";
import ColorPlugin from "./plugins/ColorPlugin.vue";
import TablePlugin from "./plugins/TablePlugin.vue";
import TextEditor from "./TextEditor.vue";
import { FULL_DART_EDITOR_NODES } from "./utils";

defineProps<{
  initialState: SerializedEditorState;
}>();

const ADDED_DIFF_BACKGROUND = `${ColorHex.LIME_GREEN}${BACKGROUND_ALPHA}`;
const REMOVED_DIFF_BACKGROUND = `${ColorHex.BRIGHT_RED}${BACKGROUND_ALPHA}`;
</script>

<template>
  <div
    class="dart-snapshot-editor min-w-0"
    :style="{ '--added-diff-background': ADDED_DIFF_BACKGROUND, '--removed-diff-background': REMOVED_DIFF_BACKGROUND }">
    <TextEditor
      namespace="snapshot"
      :nodes="FULL_DART_EDITOR_NODES"
      :initial-state="initialState"
      placeholder=""
      small-leading
      base-text
      disabled
      always-borderless>
      <template #default>
        <CodeHighlightPlugin />
        <ColorPlugin />
        <TablePlugin />
      </template>
    </TextEditor>
  </div>
</template>

<style scoped>
@reference "#frontend.css";
.dart-snapshot-editor :deep(mark:has(> .contents)) {
  @apply inline-flex rounded p-1 align-middle;
  background-color: var(--added-diff-background) !important;
  text-decoration: none !important;
}

.dart-snapshot-editor :deep(mark:has(> mark > .contents)) {
  display: contents;
  background-color: transparent !important;
  text-decoration: none !important;
}

.dart-snapshot-editor :deep(mark mark:has(> .contents)) {
  @apply opacity-60;
  background-color: var(--removed-diff-background) !important;
}
</style>
